import http, { url } from '../../http'

const API_URL = "inventory_mi"

class inventory_miAPI {

  async save(inventory_mi) { 
    const response = await http(`${API_URL}/save`, 'POST', inventory_mi)
    return response
  }

  async getAllinventory_miCompany(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  } 
  async getAllinventory_miPage(companiesID, page) {
    const response = await http(`${API_URL}/${companiesID}?page=${page}`, 'POST', {
      page: page
    })
    return response || null
  }
 

  async getinventory_mi(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateinventory_mi(id, inventory_mi) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', inventory_mi)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  /** Catálogo de periodicidades de mantenimiento y colores del semáforo (ítem 4.2.5). */
  async catalogs() {
    const response = await http(`${API_URL}/catalogs`, 'GET')
    return response || null
  }

  /**
   * URL de descarga del reporte de cumplimiento de mantenimientos en Excel (ítem 4.2.5).
   * @param {Number} companyId Empresa.
   * @param {Number} days Ventana de preaviso en días (ámbar).
   * @param {Boolean} all true para incluir también los activos inactivos.
   */
  async getExcel(companyId, days = 30, all = false) {
    const user = JSON.parse(localStorage.getItem('user'))
    const token = user && user.token ? `&access_token=${user.token}` : ''
    return url(`${API_URL}/report/excel/${companyId}?days=${days}&all=${all ? 1 : 0}${token}`)
  }
 
}

export default new inventory_miAPI()